import readinessCheckActions from '../actions/ReadinessCheckActions';

export const defaultState = { isReadinessCheckComplete: false };

export default function (state = defaultState, action) {
    switch (action.type) {
    case readinessCheckActions.types.READINESS_CHECK_COMPLETE:
        return { ...state, isReadinessCheckComplete: action.isReadinessCheckComplete };

    default:
        return state;
    }
}
